<template>
  <div
    class="chats-container"
    :class="[size ? 'chats-container--' + size : '', addBottomClass ? 'chats-container--bottom' : '']"
  >
    <ChatsBtn :size="size" />
    <ChatsList :size="size" />
    <!--    <ChatsAlert v-if="!hiddenAlert" />-->
  </div>
</template>

<script>
import ChatsBtn from './ChatsBtn'
import ChatsList from './ChatsList'
// import ChatsAlert from './ChatsAlert'
import { mapState } from 'vuex'

export default {
  name: 'Chats',
  data () {
    return {
      hiddenAlert: true
    }
  },
  props: {
    size: {
      type: String,
      default: 'large'
    }
  },
  components: {
    ChatsBtn,
    ChatsList
    // ChatsAlert
  },
  mounted () {
    if (sessionStorage.getItem('chatsOfflineAlert') === 'true') this.hiddenAlert = true
  },
  computed: {
    ...mapState({
      isOpenChatsList: state => state.chats.isOpen,
      isBtnBuyShow: state => state.productTabs.isBtnBuyShow,
      inStock: state => state.productInfo.productInfo.inStock,
      availableInStore: state => state.productInfo.productInfo.availableInStore,
      activeTab: state => state.productTabs.activeTab
    }),
    isProductInStock () {
      return this.inStock || this.availableInStore
    },
    addBottomClass () {
      if (this.activeTab !== 'description' && this.activeTab !== ' ') {
        return this.isProductInStock
      }
      return this.isProductInStock && !this.isBtnBuyShow
    }
  },
  watch: {
    isOpenChatsList (value) {
      if (value) this.hiddenAlert = true
    }
  }
}
</script>

<style scoped lang="sass">

.chats-container
  position: fixed
  z-index: 4
  right: 0
  bottom: 127px

  +mmin($tablet--hor)
    bottom: 40px

  &--bottom
    bottom: 127px

    +mmin($tablet--hor)
      bottom: 40px

  &--small
    width: 80px
    height: 80px

    +mmin($tablet--hor)
      width: 120px
      height: 120px

  &--medium
    width: 100px
    height: 100px

  &--large
    width: 120px
    height: 120px

.overflow-hidden
  .chats-container
    display: none
</style>
